import React, { useState, useEffect } from "react";
import { makeStyles, TextField, Grid, Button, Tooltip } from "@material-ui/core";
import { Formik, Form, FastField, FieldArray } from "formik";
import { isArray } from "lodash";
import NumberFormat from "react-number-format";
import ButtonWithSpinner from "../ButtonWithSpinner";
import { i18n } from "../../translate/i18n";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import DeleteSweepIcon from "@material-ui/icons/DeleteSweep";


const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  fullWidth: {
    width: "100%",
  },
  textfield: {
    width: "100%",
    fontSize: "0.875em"
  },
  row: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  control: {
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },
  buttonContainer: {
    textAlign: "right",
    padding: theme.spacing(1),
  },
  copyButtonsContainer: {
    display: "flex",
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1),
    flexWrap: "wrap",
  },
  copyButton: {
    textTransform: "none",
  },
}));

function SchedulesForm(props) {
  const { initialValues, onSubmit, loading, labelSaveButton } = props;
  const classes = useStyles();

  const [schedules, setSchedules] = useState([
    { weekday: i18n.t("queueModal.serviceHours.monday"), weekdayEn: "monday", startTimeA: "", endTimeA: "", startTimeB: "", endTimeB: "", },
    { weekday: i18n.t("queueModal.serviceHours.tuesday"), weekdayEn: "tuesday", startTimeA: "", endTimeA: "", startTimeB: "", endTimeB: "", },
    { weekday: i18n.t("queueModal.serviceHours.wednesday"), weekdayEn: "wednesday", startTimeA: "", endTimeA: "", startTimeB: "", endTimeB: "", },
    { weekday: i18n.t("queueModal.serviceHours.thursday"), weekdayEn: "thursday", startTimeA: "", endTimeA: "", startTimeB: "", endTimeB: "", },
    { weekday: i18n.t("queueModal.serviceHours.friday"), weekdayEn: "friday", startTimeA: "", endTimeA: "", startTimeB: "", endTimeB: "", },
    { weekday: i18n.t("queueModal.serviceHours.saturday"), weekdayEn: "saturday", startTimeA: "", endTimeA: "", startTimeB: "", endTimeB: "", },
    { weekday: i18n.t("queueModal.serviceHours.sunday"), weekdayEn: "sunday", startTimeA: "", endTimeA: "", startTimeB: "", endTimeB: "", },
  ]);

  useEffect(() => {
    console.log(initialValues)
    if (isArray(initialValues) && initialValues.length > 0) {
      setSchedules(initialValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues]);

  const handleSubmit = (data) => {
    console.log(data)
    onSubmit(data);
  };

  const copyMondayToWeekdays = (setFieldValue, mondaySchedule) => {
    // Copiar Segunda (index 0) para Terça até Sexta (index 1-4)
    for (let i = 1; i <= 4; i++) {
      setFieldValue(`schedules[${i}].startTimeA`, mondaySchedule.startTimeA);
      setFieldValue(`schedules[${i}].endTimeA`, mondaySchedule.endTimeA);
      setFieldValue(`schedules[${i}].startTimeB`, mondaySchedule.startTimeB);
      setFieldValue(`schedules[${i}].endTimeB`, mondaySchedule.endTimeB);
    }
  };

  const copyMondayToAllDays = (setFieldValue, mondaySchedule) => {
    // Copiar Segunda (index 0) para todos os dias (index 1-6)
    for (let i = 1; i <= 6; i++) {
      setFieldValue(`schedules[${i}].startTimeA`, mondaySchedule.startTimeA);
      setFieldValue(`schedules[${i}].endTimeA`, mondaySchedule.endTimeA);
      setFieldValue(`schedules[${i}].startTimeB`, mondaySchedule.startTimeB);
      setFieldValue(`schedules[${i}].endTimeB`, mondaySchedule.endTimeB);
    }
  };

  const clearAllSchedules = (setFieldValue) => {
    // Limpar todos os horários
    for (let i = 0; i <= 6; i++) {
      setFieldValue(`schedules[${i}].startTimeA`, "");
      setFieldValue(`schedules[${i}].endTimeA`, "");
      setFieldValue(`schedules[${i}].startTimeB`, "");
      setFieldValue(`schedules[${i}].endTimeB`, "");
    }
  };

  return (
    <Formik
      enableReinitialize
      className={classes.fullWidth}
      initialValues={{ schedules }}
      onSubmit={({ schedules }) =>
        setTimeout(() => {
          handleSubmit(schedules);
        }, 500)
      }
    >
      {({ values, setFieldValue }) => (
        <Form className={classes.fullWidth}>
          <FieldArray
            name="schedules"
            render={(arrayHelpers) => (
              <>
                <Grid spacing={4} container>
                  {values.schedules.map((item, index) => {
                  return (
                    <Grid key={index} xs={12} md={4} item>
                      <Grid container>
                        <Grid className={classes.control} xs={12} item>
                          <FastField
                            as={TextField}
                            abel={i18n.t("queueModal.serviceHours.dayWeek")}
                            name={`schedules[${index}].weekday`}
                            disabled
                            variant="outlined"
                            className={classes.fullWidth}
                            margin="dense"
                          />
                        </Grid>
                        <Grid className={classes.control} xs={12} md={6} item>
                          <FastField
                            label={i18n.t("queueModal.serviceHours.startTimeA")}
                            name={`schedules[${index}].startTimeA`}
                          >
                            {({ field }) => (
                              <NumberFormat
                                {...field}
                                variant="outlined"
                                margin="dense"
                                customInput={TextField}
                                format="##:##"
                                className={classes.fullWidth}
                                label={i18n.t("queueModal.serviceHours.startTimeA")}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid className={classes.control} xs={12} md={6} item>
                          <FastField
                            label={i18n.t("queueModal.serviceHours.endTimeA")}
                            name={`schedules[${index}].endTimeA`}
                          >
                            {({ field }) => (
                              <NumberFormat
                                {...field}
                                variant="outlined"
                                margin="dense"
                                customInput={TextField}
                                format="##:##"
                                className={classes.fullWidth}
                                label={i18n.t("queueModal.serviceHours.endTimeA")}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid className={classes.control} xs={12} md={6} item>
                          <FastField
                            label={i18n.t("queueModal.serviceHours.startTimeB")}
                            name={`schedules[${index}].startTimeB`}
                          >
                            {({ field }) => (
                              <NumberFormat
                                {...field}
                                variant="outlined"
                                margin="dense"
                                customInput={TextField}
                                format="##:##"
                                className={classes.fullWidth}
                                label={i18n.t("queueModal.serviceHours.startTimeB")}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid className={classes.control} xs={12} md={6} item>
                          <FastField
                            label={i18n.t("queueModal.serviceHours.endTimeB")}
                            name={`schedules[${index}].endTimeB`}
                          >
                            {({ field }) => (
                              <NumberFormat
                                {...field}
                                variant="outlined"
                                margin="dense"
                                customInput={TextField}
                                format="##:##"
                                className={classes.fullWidth}
                                label={i18n.t("queueModal.serviceHours.endTimeB")}
                              />
                            )}
                          </FastField>
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
              
              {/* Botões de auto-preenchimento */}
              <div className={classes.copyButtonsContainer}>
                <Tooltip title="Copia os horários de Segunda-feira para Terça até Sexta-feira">
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    startIcon={<FileCopyIcon />}
                    className={classes.copyButton}
                    onClick={() => copyMondayToWeekdays(setFieldValue, values.schedules[0])}
                  >
                    Copiar Segunda para dias úteis (Seg-Sex)
                  </Button>
                </Tooltip>
                
                <Tooltip title="Copia os horários de Segunda-feira para todos os dias da semana">
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    startIcon={<FileCopyIcon />}
                    className={classes.copyButton}
                    onClick={() => copyMondayToAllDays(setFieldValue, values.schedules[0])}
                  >
                    Copiar Segunda para todos os dias (Seg-Dom)
                  </Button>
                </Tooltip>
                
                <Tooltip title="Limpa todos os horários de todos os dias">
                  <Button
                    variant="outlined"
                    color="secondary"
                    size="small"
                    startIcon={<DeleteSweepIcon />}
                    className={classes.copyButton}
                    onClick={() => clearAllSchedules(setFieldValue)}
                  >
                    Limpar todos os horários
                  </Button>
                </Tooltip>
              </div>
            </>
            )}
          ></FieldArray>
          <div className={classes.buttonContainer}>
            <ButtonWithSpinner
              loading={loading}
              type="submit"
              color="primary"
              variant="contained"
            >
              {labelSaveButton ?? i18n.t("whatsappModal.buttons.okEdit")}
            </ButtonWithSpinner>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default SchedulesForm;
